interface FilterIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  customStyle?: React.CSSProperties;
}

export const FilterIcon: React.FC<FilterIconProps> = ({ 
  width = 20, 
  height = 20, 
  color = "#595959",
  className,
  customStyle
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={customStyle}
    >
      <path 
        d="M1.66663 3.83333C1.66663 3.36662 1.66663 3.13327 1.75745 2.95501C1.83735 2.79821 1.96483 2.67072 2.12163 2.59083C2.29989 2.5 2.53325 2.5 2.99996 2.5H17C17.4667 2.5 17.7 2.5 17.8783 2.59083C18.0351 2.67072 18.1626 2.79821 18.2425 2.95501C18.3333 3.13327 18.3333 3.36662 18.3333 3.83333V4.39116C18.3333 4.61516 18.3333 4.72716 18.3059 4.8313C18.2817 4.92359 18.2417 5.01103 18.1879 5.0898C18.1271 5.17869 18.0425 5.25204 17.8732 5.39875L12.5434 10.0179C12.3741 10.1646 12.2895 10.238 12.2287 10.3269C12.1748 10.4056 12.1349 10.4931 12.1107 10.5854C12.0833 10.6895 12.0833 10.8015 12.0833 11.0255V15.382C12.0833 15.5449 12.0833 15.6264 12.057 15.6969C12.0338 15.7591 11.996 15.8149 11.9468 15.8596C11.8912 15.9102 11.8155 15.9404 11.6642 16.001L8.83089 17.1343C8.5246 17.2568 8.37146 17.3181 8.24852 17.2925C8.14101 17.2702 8.04667 17.2063 7.986 17.1148C7.91663 17.0101 7.91663 16.8452 7.91663 16.5153V11.0255C7.91663 10.8015 7.91663 10.6895 7.88925 10.5854C7.865 10.4931 7.82507 10.4056 7.77122 10.3269C7.71044 10.238 7.62581 10.1646 7.45653 10.0179L2.12672 5.39875C1.95745 5.25204 1.87281 5.17869 1.81204 5.0898C1.75818 5.01103 1.71825 4.92359 1.694 4.8313C1.66663 4.72716 1.66663 4.61516 1.66663 4.39116V3.83333Z" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}; 